import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewChild,
	ViewEncapsulation,
	OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { TranslationGroup, TranslationSelector } from "@obg/ngx.core.content";
import { ConfigService } from "@obg/ngx.global";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { RouteAction } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { FORGOT_PASSWORD_TRANSLATIONS } from "../forgot-password.model";
import { ForgotPasswordService } from "../forgot-password.service";

@Component({
	selector: "obg-m-lg-forgot-password-container",
	templateUrl: "./lg-forgot-password.container.html",
	styleUrls: ["./lg-forgot-password.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [ForgotPasswordService],
})
export class LgForgotPasswordContainer implements OnInit {
	@ViewChild("dialog") dialogLayout!: DialogLayoutComponent;

	@HostBinding("class.obg-m-lg-forgot-password") hostCssClass = true;
	@HostBinding("attr.data-test-id") dataTestId = "forgot-password-container";

	@Input()
	@coerceBoolean()
	hideDialogWrapper = false;

	@Input()
	@coerceBoolean()
	customUsageEnabled = false;

	@Output() close = new EventEmitter();

	isBusy = false;
	success: boolean | undefined;
	fabricForgotPasswordComponent: boolean = this.forgotPasswordService.getFabricForgotPasswordFeatureFlag();
	translations$: Observable<Record<string, string | undefined>> | undefined;

	forgotPasswordIcon = "";

	constructor(
		private store: Store<CoreState>,
		private forgotPasswordService: ForgotPasswordService,
		private translationSelector: TranslationSelector,
		private config: ConfigService<ObgConfigFeAdaptiveClientCommon>
	) {}

	ngOnInit() {
		this.translations$ = this.store.pipe(
			this.translationSelector.getByKeys_v2$(FORGOT_PASSWORD_TRANSLATIONS.translations, [
				TranslationGroup.General,
				TranslationGroup.Common,
			]),
			map((keys) =>
				Object.fromEntries(keys.map((_, i) => [FORGOT_PASSWORD_TRANSLATIONS.translations[i], keys[i]]))
			)
		);

		this.forgotPasswordIcon = this.config.get((x) => x.matCommonUi.forgotPasswordIcon, "ico-checkmark");
	}

	onSuccess() {
		this.success = true;
	}

	closeDialog() {
		if (this.customUsageEnabled) {
			this.close.emit();
			return;
		}

		this.dialogLayout.isDialog
			? this.dialogLayout!.close()
			: this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
	}
}
